import Link from "next/link";
import { useSliderPosition } from "@/hooks";
import styles from "@/styles/Card.module.scss";
import { useRef } from "react";

export default function LoadMoreCard({ link, ...props }) {
  const cardRef = useRef();
  const { classNames } = useSliderPosition(props, cardRef);
  return (
    <div ref={cardRef} className={classNames}>
      <Link href={link.href}>
        {/* @next-codemod-error This Link previously used the now removed `legacyBehavior` prop, and has a child that might not be an anchor. The codemod bailed out of lifting the child props to the Link. Check that the child component does not render an anchor, and potentially move the props manually to Link. */
        }
        <div className={styles.loadMoreContainer}>
          <div className={styles.loadMore}>
            <div className={styles.loadMoreInner}>
              <span className={styles.icon}>
                <span className={styles.dot}></span>
                <span className={styles.dot}></span>
                <span className={styles.dot}></span>
              </span>
              <span>もっと見る</span>
            </div>
          </div>
        </div>
      </Link>
    </div>
  );
}
